import { Size } from 'igniteui-angular/lib/services/overlay/utilities';
import { AppModule } from '../app.module';
import {
  ContainerType,
  OverrideStatus,
  OverrideType,
  Status
} from '../enum/enum';
import { ColorSchedule } from '../rcs/admin-module/company-config/WeekColors/models/week-color.model';
import { LabelEntityType } from '../Services/enum';
import { overrides } from 'chart.js/dist/core/core.defaults';

export class loggedUserDetails {
  userName: string = '';
  userID: number = 0;
  userRole: string = '';
}

export class barcodeLookupModel {
  workingTableID: number = 0;
  departmentId: number = 0;
  categoryId: number = 0;
  productionCycleId: number = 0;
  qualityId: number = 0;
  conditionId: number = 0;
  price: number = 0.0;
  lotId: number = 0;
  productionStoreId: number = 0;
  stationId: number = 0;
  processorId: number = 0;
  qty: number = 0;
  createdDt: Date = new Date();
  createdByUserID: number = 0;
  processedFlag: boolean = false;
  newItemId: number = 0;
  status: string = '';
  companyId: number = 0;
  numberPieces: number = 0;
  sizeId: number = 0;
  pickedToProcess: boolean = false;
  brandId: number = 0;
  formatTypeId: number = 0;
  isSpecialPricing: boolean = false;
  isERPBoutique: boolean = false;
  isReprint: boolean = false;
  originalQtyPrinted: number = 0;
  barcode: string = '';
  subCategoryId: number = 0;
  userName: string = '';
  departmentDescr: string = '';
  departmentIcon: string = '';
  categoryName: string = '';
  categoryIcon: string = '';
  subCategoryName: string = '';
  subCategoryIcon: string = '';
  storeName: string = '';
  storeCode: string = '';
  stationName: string = '';
  displayName: string = '';
  color: string = '';
  isChecked: boolean = false;
  //movement
  locationId: number = 0;
  destinationLocationId: number = 0;
  location: string = '';
  locations: Array<LocationsModel> = [];
  producedforDt: Date = new Date();
  currentStoreLocation: string = '';
  currentStoreName: string = '';
  dateProduced?: Date | string;
  producedFor?: string;
  producedBy?: string;
  warehouseLocation?: string;
}

export class LocationType {
  locationTypeID: number = 0;
  locationTypeDescr: string = '';
  transffer: boolean = true;
  isSelected: boolean = true;
  active: boolean = true;
  itemLocationID: number = 0;
  itemLocation: string = '';
  location: string = '';
  userName: string = '';
  locationCd: string = '';
  createdDt: string = '';
  lastUpdatedDt: string = '';
  lastChangedByUserID: number = 0;
  createdByUserID: number = 0;
  companyID: number = 0;
}

export class ItemLocationTypes {
  locationTypeID: number = 0;
  locationTypeDescr: string = '';
  transffer: boolean = true;
  isSelected: boolean = true;
  itemLocationID: number = 0;
  itemLocation: string = '';
  locationCd: string = '';
  createdDt: string = '';
  lastUpdatedDt: string = '';
  lastChangedByUserID: number = 0;
  createdByUserID: number = 0;
}

export class posInventory {
  productID: number = 0;
  active: boolean = true;
  productDescr: string = '';
  departmentId: number = 0;
  departmentDescr: string = '';
  productName: string = '';
  categoryName: string = '';
  categoryId: number = 0;
  inventory: number = 0;
  price: number = 0;
  brandDescr: string = '';
  imageIcon: string = '';
  storeName: string = '';
  isActive: boolean = true;
  categoryTypeID: number = 0;
}

export class AIPricing {
  pricingID: number = 0;
  departmentId: number = 0;
  departmentDescr: string = '';
  categoryId: number = 0;
  categoryName: string = '';
  brandID: number = 0;
  brandName: string = '';
  poshmarkPrice: number = 0;
  ebayPrice: number = 0;
  goodwillPrice: number = 0;
  createdDt: string = '';
  companyID: number = 0;
}

export class Processor {
  processorID: number = 0;
  processorName: string = '';
  jobTitle: string = '';
  active: boolean = true;
  compnayID: number = 0;
  hireDt: string = '';
  storeId: number = 0;
  createdDt: string = '';
  lastChangedDt: string = '';
  createdByUseriD: number = 0;
  lastChangedByUserID: number = 0;
  defaultLanguage: number = 0;
}

export class Inventory {
  productionDetailId: number = 0;
  itemId: number = 0;
  inventSumId: number = 0;
  lotId: number = 0;
  barcode: string = '';
  numberOfPieces: number = 0;
  productionStoreId: number = 0;
  transferStoreId: number = 0;
  stationId: number = 0;
  processorId: number = 0;
  qtyProduced: number = 0;
  qtySold: number = 0;
  qty: number = 0;
  onHand: number = 0;
  createdDt: string = '';
  lastUpdatedDt: string = '';
  sizeId: number = 0;
  journalTypeId: number = 0;
  adjQty: number = 0;
  toLocationId: number = 0;
  fromLocationId: number = 0;
  count: number = 0;
  brandId: number = 0;
  departmentDescr: string = '';
  categoryName: string = '';
  color: string = '';
  displayName: string = '';
  storeName: string = '';
  locationTypeDesc: string = '';
  dIcon: string = '';
  cIcon: string = '';
  variance: any = '-';
  price: number = 0;
  totalPrice: number = 0;
  departmentId: number = 0;
  categoryId: number = 0;
  storeId: number = 0;
  productionCycleId: number = 0;
  isSelected: boolean = true;
  cIsSelected: boolean = true;
  pIsSelected: boolean = true;
  sIsSelected: boolean = true;
  lIsSelected: boolean = true;
  checked: boolean = true;
  varianceColor: string = 'black';
  locationId: number = 0;
  isAdjQty: boolean = false;
  index: number = 0;
}

export class production {
  departmentId: number = 0;
  CategoryID: number = 0;
  subCategoryID: number = 0;
  CategoryName: string = '';
  DepartmentDescr: string = '';
  productionCycleID: number = 0;
  qualityID: number = 0;
  conditionID: number = 0;
  price: number = 0;
  StationID: number = 0;
  UserID: number = 0;
  sizeID: number = 0;
  qty: number = 0;
  CompanyID: number = 0;
  company: string = '';
  weekColor: string = '';
  numberOfPieces: number = 0;
  userID: number = 0;
  isPrint: boolean = false;
  sizeDescr: string = '';
  storeId: number = 0;
  brandID: number = 0;
  isSpecialPrice: boolean = false;
  formatTypeId: number = 0;
  barcode: string = '';
  isReprint: boolean = false;
  addtoBin: boolean = false;
  workingTableID: number = 0;
  displayName: string = '';
  departmentDescr: string = '';
  productionStoreId: number = 0;
  categoryName: string = '';
  dateCreated: string = '';
  color: string = '';
  createdByUserID: number = 0;
  qualityDescr: string = '';
  dicon: string = '';
  cicon: string = '';
  isSelected: boolean = false;
  cIsSelected: boolean = false;
  wIsSelected: boolean = false;
  printTypeID: number = 0;
  storeName: string = '';
  printCnt: number = 0;
  numberPieces: number = 0;
  totalQty: number = 0;
  brandTypeID: number = 0;
  brandTypeName: string = '';
  brandDescr: string = '';
  companyName: string = '';
  isPrintChecked: boolean = false;
  productionforDt: string = '';
  productionCycleScheduleID: number = 0;
  currentLocationID: number = 0;
  currentStoreId: number = 0;
  isProductEventsEnabled: boolean = false;
  licensePlateId: number = 0;
  sourceContainerId: number = 0;
}
export class ProductionHistory {
  workingTableId: number = 0;
  productionCycleId: number = 0;
  displayName: string = '';
  departmentId: number = 0;
  departmentDescr: string = '';
  sizeDescr: string = '';
  categoryId: number = 0;
  subCategoryId: number = 0;
  productionStoreId: number = 0;
  categoryName: string = '';
  subCategoryName: string = '';
  dateCreated: string = '';
  producedForDate: string = '';
  color: string = '';
  createdByUserId: number = 0;
  qty: number = 0;
  price: number = 0;
  barcode: string = '';
  qualityDescr: string = '';
  dicon: string = '';
  cicon: string = '';
  isSelected: boolean = false;
  cIsSelected: boolean = false;
  wIsSelected: boolean = false;
  isReprint: boolean = false;
  qualityId: number = 0;
  conditionId: number = 0;
  sizeId: number = 0;
  printTypeId: number = 0;
  labelType: number = 0;
  formatTypeId: number = 0;
  numberOfPieces: number = 0;
  storeName: string = '';
  printCnt: number = 0;
  numberPieces: number = 0;
  totalQty: number = 0;
  brandTypeId: number = 0;
  brandTypeName: string = '';
  brandDescr: string = '';
  companyName: string = '';
  userName: string = '';
  lastUpdatedByUserName: string = '';
  isPrintChecked: boolean = false;
  locationId: number = 0;
  locationName: string = '';
  weekNumber: number = 0;
  isScanPull: boolean = false;
  isDeleted: boolean = false;
}

export class SizeDetail {
  sizeId: number = 0;
  alphaSize: string = '';
  sizeMethod: string = '';
  numericSizeRange: string = '';
  sortOrder: number = 0;
  createdDt: string = '';
  companyId: number = 0;
}

export class SizeModel {
  departmentId: number = 0;
  departmentDescr: string = '';
  categoryId: number = 0;
  categoryName: string = '';
  companyId: number = 0;
  sizes: string = '';
  sizing: SizeDetail[] = [];
  isSelected: boolean = false;
  dImageIcon: string = '';
  imageIcon: string = '';
}

// Need to delete
export class Sizes {
  sizeID: number = 0;
  alphaSize: string = '';
  sizeMethod: string = '';
  numericSizeRange: string = '';
  departmentId: number = 0;
  categoryId: number = 0;
  companyID: number = 0;
  sortOrder: number = 0;
  active: boolean = true;
  departmentDescr: string = '';
  categoryName: string = '';
  createdDt: string = '';
  SisSelected: boolean = false;
  isSelected: boolean = false;
  cIsSelected: boolean = false;
  imageIcon: string = '';
  dImageIcon: string = '';
}

export class Conditions {
  conditionId: number = 0;
  conditionDescr: string = '';
  conditionCode: string = '';
  userName: string = '';
  conditionColor: string = '';
  active: boolean = true;
  createdByUserId: number = 0;
  companyId: number = 0;
  createdDt: string = '';
  isSelected: boolean = false;
}

export class Price {
  priceID: number = 0;
  qualityID: number = 0;
  price: number = 0;
  departmentId: number = 0;
  subDepartmentID: number = 0;
  categoryId: number = 0;
  companyID: number = 1;
  active: boolean = true;
  createdDt: string = '';
  lastChangedDt: string = '';
  departmentDescr: string = '';
  categoryName: string = '';
  createdByUserID: number = 1;
  lastChangedByUserID: number = 0;
  conditionID: number = 0;
  isSelected: boolean = false;
}
export class LoginModel {
  email: string = '';
  password: string = '';
  userId: number = 0;
  fullName: string = '';
  msg: string = '';
  userRole: string = '';
  companyID: number = 0;
  company: string = '';
  userName: string = '';
  brijjusername: string = '';
  storeId: number = 0;
  ipAddress: string = '';
  accessRoleID: number = 0;
  productionAutoPrint: boolean = true;
  productionStayScreen: boolean = true;
  printPreview: boolean = false;
  productionScheduleType: string | null = null;
  isEnableSubcategory: boolean = false;
  isOPtionLock: boolean = false;
  isHidePricing: boolean = false;
  productionCycleColor: string = '';
  productionCycle: string = '';
  isNewUser: boolean = false;
  displayName: string = '';
  profileImgUrl: string = '';
  appID: number = 0;
  isActive: boolean = true;
  defaultModuleID: number = 0;
  outletID: number = 0;
  defaultProcessorLocationID?: number = 0;
  isTpmPresent: boolean = false;
  hasAccessToAdminModule: boolean = false;
  isListerPresent: boolean = false;
  isInventoryPresent: boolean = false;
  isDonationPresent: boolean = false;
  isPosPresent: boolean = false;
  isBypassLicenses: boolean = false;
  productionLimit: number | null = null;
  userSessionTimeout: number | null = null;
  apps: App[] = [];
  todaysTotalHoursLoggedIn: number = 0;
}

export class MainDepartment {
  departmentDescr: string = '';
  active: boolean = true;
  createdDt: any = new Date();
  departmentTypeDescr: string = '';
  departmentId: number = 0;
  lastUpdatedDt: any = new Date();
  imageIcon: string = '';
  fav: Boolean = false;
  isFav: Boolean = false;
  userName: string = '';
  favoriteId: number = 0;
  favoriteID: number = 0;
  //
  subDepartmentCode: string = '';
  subDepartmentName: string = '';
  //
  categoryId: number = 0;
  companyID: number = 0;
  categoryName: string = '';
  isSelected: boolean = false;
}
export class SubDepartments {
  subDepartmentCode: string = '';
  departmentId: number = 0;
  subDepartmentName: string = '';
  imageIcon: string = ' ';
}

export class SubDepartmentModel {
  categoryId: number = 0;
  companyID: number = 0;
  categoryName: string = '';
  imageIcon: string = '';
  fav: Boolean = false;
  /*  favoriteId: number = 0;*/
  active: boolean = true;
  favSubDept: Boolean = false;
  isFav: Boolean = false;
  hasSubCategory: Boolean = false;
  createdDt: any = new Date();
  departmentTypeDescr: string = '';
  departmentId: number = 0;
  lastUpdatedDt: any = new Date();
  subDepartmentCode: string = '';
  subDepartmentName: string = '';
  departmentDescr: string = '';
  userName: string = '';
  favoriteId: number = 0;
}

export class loggedInUserDetailsModel {
  userId: number = 0;
  companyID: number = 0;
  firstName: string = '';
  lastName: string = '';
  userName: string = '';
  password: string = '';
  isActive: string = '';
  storeId: number = 0;
  phone: number = 0;
  email: string = '';
  createdDt: string = '';
  createdByUserId: number = 0;
  lastChangedByUserId: number = 0;
  lastChangedDt: string = '';
  accessRoleName: string = '';
  accessRoleDescr: string = '';
}

// export class ColorsModel {
//   productionCycleId: number = 0;
//   productionCycle: string = '';
//   color: string = '';
//   active: boolean = true;
//   companyId: number = 0;
//   weekNumber: number = 0;
//   createdDt: string = '';
//   lastUpdatedDt: string = '';
//   cycleStartDt: string = '';
//   cycleEndDt: string = '';
//   pullCycle: string = '';
//   isSelected: boolean = false;
//   displayName: string = '';
//   sortOrder: number = 0;
// }

export class Companieslist {
  id: number = 0;
  rcsCompanyID: string = '';
  companyName: string = '';
  locationCnt: string = '';
  createdDt: string = '';
  createdByUser: string = '';
  isChecked: boolean = true;
}

export class Company {
  companyId: number = 0;
  id: number = 0;
  rcsCompanyID: string = '';
  companyID: number = 0;
  companyName: string = '';
  compnayWebsite: string = '';
  address1: string = '';
  address2: string = '';
  city: string = '';
  state: string = '';
  zip: string = '';
  phone: string = '';
  email: string = '';
  userTimeOutInMin: number = 0;
  companyWebsite: string = '';
  primaryContactName: string = '';
  companyLogo: any = '';
  createdByUserID: number = 0;
  isChecked: boolean = true;
  printPreview: boolean = true;
  licenseList: Array<LicenseModel> = [];
  isBypassLicenses: boolean = true;
  isEnableSubcategory: boolean = true;
  assignedLicenses: number = 0;
}

export class Departments {
  departmentDescr: string = '';
  departmentId: number = 0;
  subDepartmentName: string = '';
  extID: string = '';
  subDepartmentCode: string = '';
  active: boolean = true;
  companyID: number = 0;
  isUniqueItem: boolean = false;
  createdDt: string = '';
  lastUpdatedDt: string = '';
  lastChangedByUserID: number = 0;
  createdByUserID: number = 0;
  sortOrder: number = 0;
  imageIcon: string = '';
  userName: string = '';
  isSelected: boolean = false;
  storeGroupId: number = 0;
  storeGroupName: string = '';
  pricingTypeID: number = 0;
  percentage: number = 0;
  status: string = '';
}

export interface Language {
  languageID: number;
  language: string;
}
export class Module {
  moduleID: number = 0;
  moduleName: string = '';
  moduleDescription: string = '';
  active: boolean = false;
  imageUrl: string = '';
  createdDt: string = '';
  createdByUserID: number = 0;
  lastChangedDt: string = '';
  lastChangedBysUserID: number = 0;
}
export class usersDetails {
  storeId: number = 0;
  userID: number = 0;
  firstName: string = '';
  lastName: string = '';
  password: string = '';
  userName: string = '';
  createdBy: string = '';
  fullName: string = '';
  isActive: boolean = true;
  skipOutlets: boolean = true;
  phone: string = '';
  email: string = '';
  createdDt: string = '';
  createdByUserID: number = 0;
  lasetChangedByUserID: number = 0;
  lasetChangedDt: string = '';
  accessRoleID: number = 0;
  accessRoleName: string = '';
  accessRoleDescr: string = '';
  companyID: number = 0;
  isSelected: boolean = false;
  IisSelected: boolean = false;
  cIsSelected: boolean = false;
  jIsSelected: boolean = false;
  aIsSelected: boolean = false;
  languageID: number = 0;
  moduleID: number = 0;
  jobTitle: string = '';
  label: string = '';
  time: string = '';
  storeName: string = '';
  store: string = '';
  language: string = '';
  moduleName: string = '';
  defaultModuleID: number = 0;
  defaultLangID: number = 0;
  defaultProcessorLocationID: number = 0;
  processorName: string = '';
  company: string = '';
  productionAutoPrint: boolean = true;
  productionStayScreen: boolean = true;
  storeCode: string = '';
  isNewUser: boolean = false;
  goalTypeID: number = 0;
  goalDescr: string = '';
  goalGroupID: number = 0;
  goalGroup: string = '';
  // Updated Fields For POS User
  displayName: string = '';
  profileImgUrl: string = '';
  appID: number = 0;
  outletsIds: string = '';
  logInTime: string = '';
  logOutTime: string = '';
  outletID: number = 0;
}

export class goals {
  goalId: number = 0;
  goalName: string = '';
  goalDescr: string = '';
  userName: string = '';
  goalValue: string = '';
  goalValueId: number = 0;
  goalIntervals: string = '';
  groupName: string = '';
  goalIntervalId: number = 0;
  goalGroupId: number = 0;
  goalTypeId: number = 0;
  goalGroupDescription: string = '';
  goalCnt: number = 0;
  createdDt: string = '';
  lastUpdatedDt: string = '';
  createdByUserId: number = 0;
  lastChangedByUserId: number = 0;
  active: boolean = true;
  isSelected: boolean = false;
  gIsSelected: boolean = false;
  companyId: number = 0;
}

export class grades {
  qualityId: number = 0;
  qualityColor: string = '';
  qualityDescr: string = '';
  createdDt: string = '';
  lastChangedDt: string = '';
  createdByUserId: number = 0;
  lastChangedByUserId: number = 0;
  companyId: number = 0;
  active: boolean = true;
  qualityCode: string = '';
  isSelected: boolean = false;
  userName: string = '';
}

export class Stations {
  stationId: number = 0;
  storeId: number = 0;
  companyId: number = 0;
  stationName: string = '';
  storeName: string = '';
  title: string = '';
  active: boolean = true;
  status: boolean = true;
  location: string = '';
  createdDt: string = '';
  lastChangedDt: string = '';
  createdByUserId: number = 0;
  createdByUser: string = '';
  createdUserId: number = 0;
  isSelected: boolean = false;
  sIsSelected: boolean = false;
  licenseID: number = 0;
  licenseNumber: string = '';
  statusText: string = '';
  userID: number = 0;
  userName: string = '';
  currentlyAssignedToUsername: string = '';
  currentlyAssignedToUserId: number = 0;
}

export class BrandModels {
  brandId: number = 0;
  companyID: number = 0;
  departmentId: number = 0;
  brandCategoryID: number = 0;
  categoryId: number = 0;
  brandDescr: string = '';
  departmentDescr: string = '';
  active: Boolean = true;
  createdUserName: string = '';
  createdDt: any = new Date();
  createdUserId: number = 0;
  isSelected: boolean = false;
  brandTypeID: number = 0;
  brandTypeName: string = '';
  brandTypeAction: string = '';
  isBrandSelected: boolean = false;
  isDeptSelected: boolean = false;
  imageIcon: string = '';
  dImageIcon: string = '';
}

export class BrandTypes {
  brandTypeID: number = 0;
  brandTypeName: string = '';
  brandTypeAction: string = '';
  createdDt: string = '';
  createdByUserID: number = 0;
  companyID: number = 0;
  active: boolean = true;
  isBrandSelected: boolean = true;
}

export class Stores {
  storeId: number = 0;
  storeCode: string = '';
  storeName: string = '';
  goalGroup: string = '';
  storeTypeId: number = 0;
  goalGroupID: number = 0;
  goalTypeID: number = 0;
  goalDescr: string = '';
  active: Boolean = true;
  rcsLocationID: string = '';
  compnayID: number = 0;
  createdDt: string = '';
  lastUpdatedDt: string = '';
  createdByUserID: number = 0;
  lastChangedByUserID: number = 0;
  storeGroupId: number = 0;
  userName: string = '';
  storeType: string = '';
  storeLocationIDString: number[] = [];
  storeLocationIDs: string = '';
  storeGrp: string = '';
  isSelected: boolean = false;
  SisSelected: boolean = false;
  cIsSelected: boolean = false;
  timeZoneDescr: string = '';
  timeZoneID: number = 0;
  defaultWarehouseLocationId: number = 0;
}

export class StoreTimeZoneModel {
  timeZoneID: number = 0;
  timeZoneDescr: string = '';
  createdDt: string = '';
  createdByUserID: number = 0;
  lastUpdatedDt: string = '';
  lastUpdatedByUserID: number = 0;
  isSelected: boolean = false;
  createdByUserName: string = '';
  lastUpdatedByUserName: string = '';
}

export class Categories {
  categoryId: number = 0;
  departmentId: number = 0;
  companyID: number = 0;
  categoryName: string = '';
  extID: string = '';
  active: boolean = true;
  createdDt: string = '';
  createdByUserID: number = 0;
  lastChangedDt: string = '';
  lastChangedByUserID: number = 0;
  departmentDescr: string = '';
  userName: string = '';
  imageIcon: string = '';
  dImageIcon: string = '';
  isSelected: boolean = false;
  cIsSelected: boolean = false;
  printTypeID: number = 0;
  printType: String = '';
  DisSelected: boolean = false;
  sizing: Array<Sizes> = [];
}
export class subCategories {
  categoryId: number = 0;
  subCategoryID: number = 0;
  parentSubCategoryID: number = 0;
  departmentId: number = 0;
  companyID: number = 0;
  categoryName: string = '';
  extID: string = '';
  subCategoryName: string = '';
  active: boolean = true;
  createdDt: string = '';
  createdByUserID: number = 0;
  lastChangedDt: string = '';
  lastChangedByUserID: number = 0;
  departmentDescr: string = '';
  userName: string = '';
  imageIcon: string = '';
  dImageIcon: string = '';
  isSelected: boolean = false;
  cIsSelected: boolean = false;
  printTypeID: number = 0;
  printType: String = '';
  displayName: String = '';
  DisSelected: boolean = false;
  sizing: Array<Sizes> = [];
  children?: subCategories[];
  favoriteId: number = 0;
  defaultLabelTypeID: number = 0;
}

export class DeploymentHistoryDetailsModel {
  deploymentHistoryDetailId: number = 0;
  deploymentHistoryId: number = 0;
  releasedFeatures: string = '';
  remarks: string = '';
}

export class DeploymentHistoryModel {
  deploymentHistoryId: number = 0;
  deploymentDate: any = new Date();
  versionNo: string = '';
  deploymentHistoryDetails: DeploymentHistoryDetailsModel[] = [];
  detailsLoaded: boolean = false;
  expanded: boolean = false;
}

export class pricetypeconfig {
  deptPriceConfigId: number = 0;
  department: string = '';
  pricingDescr: string = '';
  storeGroupId: number = 0;
  pricingTypeId: number = 0;
  companyId: number = 0;
  effectiveDate: string = '';
  expirationDate: string = '';
  createdDtP: string = '';
  lastUpdatedDt: string = '';
  description: string = '';
}
export class storegrp {
  storeGroupId: number = 0;
  name: string = '';
  storeGrpDescr: string = '';
  userName: string = '';
  active: boolean = true;
  createdDt: string = '';
  createdByUserID: number = 0;
  lastUpdatedDt: string = '';
  lastChangedUserID: number = 0;
  companyID: number = 0;
  isSelected: boolean = true;
}

export class Metadata {
  createdAt: string;
  createdById: number;
  createdBy: string;
  lastModifiedAt: string | null;
  lastModifiedById: number | null;
  lastModifiedBy: string | null;

  constructor() {
    this.createdAt = '';
    this.createdById = 0;
    this.createdBy = '';
    this.lastModifiedAt = null;
    this.lastModifiedById = null;
    this.lastModifiedBy = null;
  }
}

export class StoreGroupModel {
  id: number;
  name: string;
  description: string;
  status: number;
  companyId: number;
  storeCount: number;
  metadata: Metadata;

  constructor() {
    this.id = 0;
    this.name = '';
    this.description = '';
    this.status = 0;
    this.companyId = 0;
    this.storeCount = 0;
    this.metadata = new Metadata();
  }
}

export class deptpriceconfig {
  companyDescr: string = '';
  priceId: number = 0;
  companyId: number = 1;
  department: string = '';
  description: string = '';
  companyName: string = '';
  name: string = '';
  deptPriceConfigId: number = 0;
  effectiveDt: any = '';
  expirationDt: any = '';
  pricingTypeId: number = 0;
  storeGroupId: number = 0;
  departmentId: number = 0;
  categoryName: string = '';
  subCategoryName: string = '';
  qualityDescr: string = '';
  price: number = 0;
  conditionDescr: string = '';
  imageIcon: string = '';
  cImage: string = '';
  sImage: string = '';
  cIsSelected: boolean = false;
  isSelected: boolean = false;
  configSelected: boolean = false;
  qualitySelected: boolean = false;
  storeGroupIdSelected: boolean = false;
  conditionIdSelected: boolean = false;
  companyIdSelected: boolean = false;
  conditionId: number = 0;
  categoryId: number = 0;
  subCategoryId: number = 0;
  qualityId: number = 0;
  qualityColor: string = '';
  conditionName: string = '';
  qualityName: string = '';
  conditionColor: string = '';
  isChecked: boolean = false;
}

export class pricing {
  categoryId: number = 0;
  categoryName: string = '';
  companyId: number = 0;
  conditinoId: number = 0;
  departmentDescr: string = '';
  departmentId: number = 0;
  price: number = 0;
  priceing: number = 0;
  pricingTypeId: number = 0;
  qualityId: number = 0;
  storeGroupId: number = 0;
}

export class UserFavoriteModal {
  favoriteId: number = 0;
  userId: number = 0;
  departmentId: number = 0;
  categoryId: number = 0;
  subCategoryId: number = 0;
  companyId: number = 0;
  redirectLink: string = '';
  createdDt: any = new Date();
  createdByUserId: number = 0;
  active: boolean = true;
  // Properties from DepartmentCategoryModel
  printTypeID: number = 0;
  categoryName: string = '';
  subCategoryName: string = '';
  printType: string = '';
  lastChangedDt: string = '';
  lastChangedByUserID: number = 0;
  imageIcon: string = '';
  dImageIcon: string = '';
  departmentDescr: string = '';
  userName: string = '';
  fav: boolean = true;
  isFav: boolean = true;
  favoriteID: number = 0;
  hasSubCategory: boolean = false;
}

export class StoreType {
  storeTypeID: number = 0;
  storeTypeDescr: string = '';
  createdDt: string = '';
  lastChangedDt: string = '';
  active: boolean = true;
  isSelected: boolean = true;
  userName: string = '';
}

export class Labels {
  id: number = 0;
  name: string = '';
  description: string = '';
  frontPreview: string = '';
  backPreview: string = '';
  zplCode: string = '';
  printerType: number = 0;
  status: Status = Status.Active;
  createdAt: string = '';
  createdById: number = 0;
  lastModifiedById: number = 0;
  printerName: string = '';
  lastModifiedAt: string = '';
  createdBy: string = '';
  companyId: number = 0;
  isSelected: boolean = true;
  labelEntityType: LabelEntityType = LabelEntityType.Product;
}

export class DepartmentWithFavorite {
  departmentDescr: string = '';
  active: boolean = true;
  createdDt: any = new Date();
  departmentTypeDescr: string = '';
  departmentId: number = 0;
  lastUpdatedDt: any = new Date();
  imageIcon: string = '';
  fav: Boolean = false;
  userName: string = '';
  favoriteId: number = 0;
}

export class Scrape {
  ItemName: string = '';
  Price: number = 0;
  ListingUrl: string = '';
}

export class LinksModel {
  linkID: number = 0;
  linkName: string = '';
  status: boolean = true;
  link: string = '';
  icon: string = '';
  isActive: boolean = false;
}

export class CartItems {
  cart = [
    {
      ProductId: 0,
      Quantity: 0,
      UnitPrice: 0
    }
  ];
}

export class ProductDetails {
  productID = 0;
  productName = '';
  quantity = 1;
  unitPrice = 0.0;
  barcode = '';
}

export class ProductQuantity {
  ProductId = 0;
  Quantity = 0;
  OrderId = 0;
}

export class ProductInput {
  productId = 0;
  productName = '';
}

export class customPosMenuOrder {
  userId: number = 0;
  orderList: Array<number> = [];
}

export class PosMenuModel {
  menuId: number = 0;
  icon: string = '';
  menu: string = '';
  path: string = '';
}

export class PosThemeModel {
  companyID: number = 0;
  loginLogo?: File | null = null;
  colorTheme: string = '';
  faviconLogo?: File | null = null;
  headerLogo?: File | null = null;
}

export class PosThemeEncodedModel {
  companyID: number = 0;
  loginLogoBase64: string = '';
  colorTheme: string = '';
  faviconBase64: string = '';
  headerBase64: string = '';
}

export class PreviousPosThemeModel {
  ThemeID: number = 0;
  previousLoginLogoBase64: string = '';
  previousHeaderLogoBase64: string = '';
  previousFaviconLogoBase64: string = '';
}

export class setPreviousThemeModel {
  companyID: number = 0;
  loginLogo: string = '';
  headerLogo: string = '';
  faviconLogo: string = '';
  colorTheme: string = '';
}

export class AccessRoles {
  accessRoleID: number = 0;
  accessRoleName: string = '';
  accessRoleDescr: string = '';
  active: boolean = true;
  createdDt: string = '';
  createdByUserID: number = 0;
  lasetChangedByUserID: number = 0;
  lasetChangedDt: string = '';
  companyID: number = 0;
  userName: string = '';
  appID: number = 0;
  isRolePresent: boolean = false;
  userPermissions: Array<Permissions> = [];
  isAddDisabled: boolean = false;
  isEditDisabled: boolean = false;
  isOptionLock: boolean = false;
  isHidePricing: boolean = false;
}

export class Permissions {
  modelFormFieldAccessID: number = 0;
  userID: number = 0;
  formFieldID: number = 0;
  isAdd: boolean = true;
  isEdit: boolean = true;
  isView: boolean = true;
  accessRoleID: number = 0;
  formMasterID: number = 0;
  moduleID: number = 0;
  formFieldName: string = '';
  formMasterName: string = '';
  moduleName: string = '';
  isAddDisabled: boolean = false;
  isEditDisabled: boolean = false;
}

export class FormPermissions {
  modelFormFieldAccessID: number = 0;
  userID: number = 0;
  formFieldID: number = 0;
  isAdd: boolean = true;
  isEdit: boolean = true;
  isView: boolean = true;
  accessRoleID: number = 0;
  formMasterID: number = 0;
  moduleID: number = 0;
  formFieldName: string = '';
  formMasterName: string = '';
  moduleName: string = '';
  isAddDisabled: boolean = true;
  isEditDisabled: boolean = true;
  isRolePresent: boolean = false;
}

export class UsersModelForEmail {
  createdBy: string = '';
  email: string = '';
  emailID: string = '';
  fullName: string = '';
  userName: string = '';
  passWord: string = '';
  appID: number = 0;
  companyLogo: string = '';
  companyName: string = '';
  stationName: string = '';
  licenseQty: number = 0;
}

export class EmpReportTable {
  id: number = 0;
  createdByUserID: number = 0;
  departmentId: number = 0;
  categoryId: number = 0;
  store: string = '';
  userName: string = '';
  categoryName: string = '';
  departmentDescr: string = '';
  price: number = 0;
  qty: number = 0;
  totalHoursLogged: number = 0;
}

export class EmployeeReport {
  storeId: number = 0;
  storeName: string = '';
  userName: string = '';
  categoryName: string = '';
  departmentDescr: string = '';
  totalAmount: number = 0;
  totalQuantity: number = 0;
  totalHoursLogged: number = 0;
}

export class EmpReportQty {
  id: number = 0;
  name: string = '';
  store: string = '';
  qtyArray: Array<{
    price: number;
    qty: number;
    hours: number;
    userName: string;
  }> = [];
  pieces: number = 0;
  value: number = 0;
  hours: number = 0;
  valuePerHour: number = 0;
  apop: number = 0;
}

export class EmpReportsTotal {
  totalQtyArray: Array<{ price: number; qty: number; hours: number }> = [];
  pieces: number = 0;
  value: number = 0;
  hours: number = 0;
  valuePerHour: number = 0;
  apop: number = 0;
}

/*Api Users Model*/
export class ApiUsers {
  id: number = 0;
  userName: string = '';
  createdByUserName: string = '';
  companyName: String = '';
  password: string = '';
  active: boolean = true;
  createdDt: string = '';
  createdByUserID: number = 0;
  lastUpdatedDt: string = '';
  lastUpdatedByUserID: number = 0;
  api: string = '';
  companyID: number = 0;
  isSelected: boolean = false;
}

export class IconsModel {
  imageIcon: string = '';
  departmentDescr: string = '';
  categoryName: string = '';
}

/*excel data formating models*/
export class RowData {
  id: number = 0;
  name: string = '';
  [key: string]: any; // Allow additional dynamic keys
  pieces?: number = 0;
  value?: number = 0;
  hours?: number = 0;
  valuePerHour?: number = 0;
  apop?: number = 0;
}
export class LicenseModel {
  licenseID: number = 0;
  billingID: number = 0;
  licenseNumber: string = '';
  companyID: number = 0;
  descr: string = '';
  active: boolean = true;
  createdDt: string = '';
  createdbyUserID: number = 0;

  //Extra properties for license format data.
  licenseFormatID: number = 0;
  formatName: string = '';
  userName: string = '';
  passWord: string = '';
  appID: number = 0;
  billingValue: number = 0;
  companyName: string = '';
  stationName: string = '';
  licenseQty: number = 0;
  licenseList: any = [];
  assignedLicenses: number = 0;
}

export class RequestLicenseQtyModel {
  EmailID: string = '';
  SuperAdminEmail: string = '';
  CompanyName: string = '';
  FullName: string = '';
  LicenseQty: number = 0;
}

export interface InputData {
  PeriodStartDate: string;
  CategoryID: number;
  BrandID: number;
  [key: string]: any;
  BrandName: string;
  CategoryName: string;
  ClosingInventory: number;
  Total_Revenue: number;
  Cost_of_Goods_Sold: number;
  Margin: number;
  Avrage_Discount_percentage: number;
  Avg_Sales_Value: number;
  Avg_Item_Per_Sale: number;
  Inventory_Cost: number;
  Average_Supply_Price: number;
  Days_Cover: number;
  CurrentInventory_Value: number;
  Sell_Through_Rate: number;
  RetailValue: number;
  Item_Sold: number;
  Sales_Count: number;
  CustomerCount: number;
  FirstSaleDate: any;
  LastSaleDate: any;
  ProductCreated: any;
  StockReorderPoint: number;
  InboundInventory: number;
  Item_Received: number;
}

export interface MeasuredValue {
  columnId: number;
  value: number | string;
  isShow: boolean;
}

export interface AggregatedData {
  PeriodStartDate: string;
  ProductCount: number;
  CategoryName: string;
  ClosingInventory: number;
  Total_Revenue: number;
  Cost_of_Goods_Sold: number;
  Margin: number;
  Avrage_Discount_percentage: number;
  Avg_Sales_Value: number;
  Avg_Item_Per_Sale: number;
  Inventory_Cost: number;
  Average_Supply_Price: number;
  Days_Cover: number;
  CurrentInventory_Value: number;
  Sell_Through_Rate: number;
  RetailValue: number;
  Item_Sold: number;
  Sales_Count: number;
  CustomerCount: number;
  FirstSaleDate: any;
  LastSaleDate: any;
  ProductCreated: any;
  StockReorderPoint: number;
  InboundInventory: number;
  Item_Received: number;
  measuredValues: MeasuredValue[];
  Return_Count: number;
  Return_Percent: number;
  Return_Amount: number;
}

export class WeekColorPullModel {
  categoryId: number = 0;
  categoryName: string = '';
  departmentId: number = 0;
  departmentDescr: string = '';
  productionCycleID: number = 0;
  prodcutionCycle: string = '';
  onHand: number = 0;
  cycleStartDt: string = '';
  cycleEndDt: string = '';
  dIcon: string = '';
  cIcon: string = '';
  color: string = '';
  weekNumber: number = 0;
  cIsSelected: boolean = false;
  dIsSelected: boolean = false;
}

export class PastProductionCycleModel {
  productionCycleID: number = 0;
  currentProductionCycle: string = '';
  weekNumber: number = 0;
  color: string = '';
}

export class LicenseBillingDetails {
  billingID: number = 0;
  billingValue: number = 0.0;
  companyID: number = 0;
  createdDt: Date = new Date();
  lastUpdatedDt: Date = new Date();
  createdByUserID: number = 0;
  lastUpdatedByUserID: number = 0;
}

export class OutletPreference {
  userOutletID: number = 0;
  outletID: number = 0;
  userID: number = 0;
  isPreferenceSelected: boolean = false;
}

// export class ColorScheduleModel {
//   companyID: number = 0;
//   daysInCycle: number = 0;
//   scheduleStartDate: Date = new Date();
//   scheduleEndDate: Date   = new Date();
//   createdByUserID: number = 0;
// }

// ------------------------------------ Company Management Models ------------------------------
export class BaseUserModel {
  userId: number = 0;
  companyId: number = 0;
  fullName: string = '';
  profileImgUrl: string = '';
  displayName: string = '';
  roles: Userroles[] = [];
}

export class Userroles {
  string: string = '';
}

export class UserRolesModel {
  id: number = 0;
  name: string = '';
  appId: number = 0;
  appName: string = '';
  permissions: UserPermissionsModel[] = [];
}

export class UserPermissionsModel {
  id: number = 0;
  name: string = '';
}

export class UserModel {
  id: number = 0;
  firstName: string = '';
  middleName?: string = '';
  lastName: string = '';
  displayName?: string = '';
  companyId: number = 0;
  status: number = 0;
  username: string = '';
  email: string = '';
  emailConfirmed?: boolean | null;
  phoneNumber: string = '';
  phoneNumberConfirmed?: boolean | null;
  twoFactorEnabled: boolean = false;
  lockoutEnd?: Date | null;
  lockoutEnabled: boolean = false;
  accessFailedCount: number = 0;
  jobTitle?: string | null;
  hireDate?: Date | null;
  defaultGoalGroupId: number = 0;
  defaultGoalTypeId: number = 0;
  defaultLanguageId: number = 0;
  defaultModuleId: number = 0;
  defaultStoreId: number = 0;
  defaultStoreLocationId: number = 0;
  defaultPosStoreId: number = 0;
  productionAutoPrint: boolean = false;
  productionStayScreen: boolean = false;
  profileFileId?: number | null;
  lastLoginAt?: Date | null;
  lastLogoutAt?: Date | null;
  passwordHash: string = '';
  salt: string = '';
  mustChangePasswordOnLogin: boolean = false;
  profileFileUrl?: string | null;
  invitationStatus: number = 0;
  roles: Role[] = [];
  apps: App[] = [];
  currentWeekCycle?: CurrentWeekCycle | null = new CurrentWeekCycle();
  company = {
    id: 0,
    name: ''
  };
  isTpmPresent: boolean = false;
  isListerPresent: boolean = false;
  isDonationPresent: boolean = false;
  isPosPresent: boolean = false;
  isInventoryPresent: boolean = false;
  isBypassLicenses: boolean = false;
  userSessionTimeout: number | null = null;
}

export class Role {
  id: number = 0;
  name: string = '';
}

export class App {
  id: number = 0;
  name: string = '';
  roles: Role[] = [];
}

export class CurrentWeekCycle {
  productionColor: string | null = '';
  productionCycleId: number | null = 0;
  productionDisplayName: string | null = '';
  weekNumber: number | null = 0;
}

export class WarehouseLocationsModels {
  warehouseId: number = 0;
  zoneId: number = 0;
  storeId: number = 0;
  profileId: number = 0;
  name: string = '';
  isSystemDefault: boolean = false;
  aisleName: string = '';
  rackName: string = '';
  shelfName: string = '';
  binName: string = '';
  companyId: number = 0;
  id: number = 0;
  createdAt: string = '';
  createdById: number = 0;
  lastModifiedAt: string = '';
  lastModifiedById: number = 0;
  eligibleForMovement: boolean = false;
  mustAdjustStock: boolean = false;
}

//#region TPM licensing
export class TpmLicenseModel {
  id: number = 0;
  companyId: number = 0;
  subscriptionId: number = 0;
  licenseId: number = 0;
  licenseKey: string = '';
  status: number = 0;
  statusText: string = '';
  currentlyAssignedToUserId: number = 0;
  currentlyAssignedToId: number | null = null;
  currentlyAssignedToUsername: string = '';
  assignments: any[] = [];
}

export class CreateStationSessionResponse {
  sessionId: string = '';
}

export type UserStationSessionStatus = 'Active' | 'Revoked' | 'Unknown';
export type UserStationReleaseReason =
  | 'Unknown'
  | 'Migrated'
  | 'EndedByAdmin'
  | 'UserLogout'
  | 'Expired';

export class HeartbeatLicenseResponse {
  status: UserStationSessionStatus = 'Unknown';
  reason: UserStationReleaseReason | null = null;
  retryAfterSeconds: number = 60;
}

export class CompanyPortalCompanyModel {
  id: number = 0;
  name: string = '';
  status: number = 0;
  code: string | null = null;
  email: string = '';
  phoneNumber: string = '';
  website: string | null = null;
  logoUrl: string = '';
  blobFileId: number | null = 0;
  businessTypeId: number | null = null;
  teamSizeId: number | null = null;
  currency: string | null = null;
  userTimeoutInMin: number | null = null;
  showPrintPreview: boolean = true;
  inProduction: boolean = true;
  isMultipleStore: boolean = true;
  isBypassLicenses: boolean = true;
  isEnableSubcategory: boolean = true;
  primaryContact: any;
  address: any;
  createdAt: string = '';
  companyUsersCount: number = 0;
  subscription: any;
}

export class DateRangeModel {
  companyID: number = 0;
  reportType: string = '';
  Measure: string = 'hour';
  Comparison: boolean = true;
  all: boolean = false;
  specificPeriod: boolean = true;
  specificDate: boolean = false;
  hour: boolean = true;
  day: boolean = false;
  week: boolean = false;
  month: boolean = false;
  quarter: boolean = false;
  year: boolean = false;
  hourModel: HourModel = new HourModel();
  dayModel: DayModel = new DayModel();
  weekModel: WeekModel = new WeekModel();
  monthModel: MonthModel = new MonthModel();
  quarterModel: QuarterModel = new QuarterModel();
  yearModel: YearModel = new YearModel();
  fromDate: string = '';
  toDate: string = '';
  currentDate: string = '';
  startDate: any;
  endDate: any;
  reportName: string = '';
  isDateRangeSelected: boolean = false;
}

export class HourModel {
  hourtoDate: boolean = true;
  previousHour: boolean = false;
  isNPreviousHour: boolean = false;
  nPreviousHour: number = 1;
  isnPreviousHourWithDate: boolean = false;
  nPreviousPeriodHourWithDate: number = 1;
  startingDate: string = new Date().toISOString().split('T')[0];
}

export class DayModel {
  daytoDate: boolean = true;
  previousDay: boolean = false;
  isNPreviousDay: boolean = false;
  nPreviousDay: number = 1;
  isnPreviousDayWithDate: boolean = false;
  nPreviousPeriodDayWithDate: number = 1;
  startingDate: string = new Date().toISOString().split('T')[0];
}
export class WeekModel {
  weektoDate: boolean = true;
  previousWeek: boolean = false;
  isNPreviousWeek: boolean = false;
  nPreviousWeek: number = 1;
  isnPreviousWeekWithDate: boolean = false;
  nPreviousPeriodWeekWithDate: number = 1;
  startingDate: string = new Date().toISOString().split('T')[0];
}
export class MonthModel {
  monthtoDate: boolean = true;
  previousMonth: boolean = false;
  isNPreviousMonth: boolean = false;
  nPreviousMonth: number = 1;
  isnPreviousMonthWithDate: boolean = false;
  nPreviousPeriodMonthWithDate: number = 1;
  startingDate: string = new Date().toISOString().split('T')[0];
}
export class QuarterModel {
  quartertoDate: boolean = true;
  previousQuarter: boolean = false;
  isNPreviousQuarter: boolean = false;
  nPreviousQuarter: number = 1;
  isnPreviousQuarterWithDate: boolean = false;
  nPreviousPeriodQuarterWithDate: number = 1;
  startingDate: string = new Date().toISOString().split('T')[0];
}
export class YearModel {
  yeartoDate: boolean = true;
  previousYear: boolean = false;
  isNPreviousYear: boolean = false;
  nPreviousYear: number = 1;
  isnPreviousYearWithDate: boolean = false;
  nPreviousPeriodYearWithDate: number = 1;
  startingDate: string = new Date().toISOString().split('T')[0];
}

//Override used Model
export class LicenseplateItems {
  id: number = 0;
  licensePlateId: number = 0;
  quantity: number = 0;
  type: number = 0;
  productId: number = 0;
  label: string = '';
  isSerialized: boolean = false;
  companyId: number = 0;
}
export class LicensePlateItemSerial {
  id: number = 0;
  licensePlateItemId: number = 0;
  serialNumber: string = '';
}

export class ProductionOverrideLicensePlates {
  id: number = 0;
  productionOverrideId: number = 0;
  licensePlateId: number = 0;
}
export interface OverrideWithLicensePlates {
  sourceStoreId: number;
  destinationStoreId: number;
  description: string;
  weekColor: string;
  weekColorDate: string;
  reminderDate: string;
  companyId: number;
  id: number;
  licensePlates: LicensePlateWrapper[];
  warehouseLocationId: number;
  status: number;
  type: number;
  isDeletable: boolean;
}

export interface LicensePlateWrapper {
  productionOverrideId: number;
  licensePlateId: number;
  licensePlate: LicensePlates;
}

export class ProductionOverride {
  id: number = 0;
  companyId: number = 0;
  sourceStoreId: number = 0;
  destinationStoreId: number = 0;
  description: string = '';
  weekColor: string = '';
  weekColorDate: string = new Date().toISOString().split('T')[0];
  reminderDate: string = new Date().toISOString().split('T')[0];
  status: number = OverrideStatus.Active;
  type: number = OverrideType.DateSpecific;
  colorSchedule?: ColorSchedule;
}

export class LicensePlates {
  id: number = 0;
  //licensePlateName: string='';
  associationId: number = 0;
  associationName: number = 0;
  referenceNumber: string = '';
  warehouseLocationId: number = 0;
  status: number = 0;
  description: string = '';
  companyId: number = 0;
  createdAt: string = '';
  createdById: number = 0;
  lastModifiedAt: string = '';
  lastModifiedById: number = 0;
}

//Movement

export class MovementItemModel {
  id: number = 0;
  quantity: number = 0;
  actualQuantity: number = 0;
  sourceWarehouseLocationId: number = 0;
  sourceWarehouseLocation: string = '';
  destinationWarehouseLocation: string = '';
  destinationWarehouseLocationId: number = 0;
  weekColor: string = '';
  licensePlateId: any;
  productId: number = 0;
  status: number = 0;
  productDepartmentId: number = 0;
  productCategoryId: number = 0;
  warehouseLocationId: number = 0;
  departmentName: string = '';
  categoryName: string = '';
  amount: number = 0;
  movementLogs: Array<MovementItemLogModel> = [];
}

export class MovementItemLogModel {
  id: number = 0;
  barcode: string = '';
  movementItemId: number = 0;
  sourceLocationId: number = 0;
  destinationLocationId: number = 0;
}
export class MovementModel {
  referenceNumber: string = '';
  storeId: number = 0;
  id: number = 0;
  status: number = 0;
  store: string = '';
  statusDescr: string = '';
  journalType: number = 0;
  companyId: number = 0;
  cancelledReason: string = '';
  note: string = '';
  createdAt: any;
  amount: number = 0;
  productionCycleId: number = 0;
  isItemCountSkipped: boolean = false;
  movementItems: MovementItemModel[] = [];
  createdById: number = 0;
  completedBy: string = '';
}

export class LocationsModel {
  id: number = 0;
  companyId: number = 0;
  name: string = '';
  adjustQuantity: boolean = false;
  eligibleForMovement: boolean = false;
  createdAt: string = '';
  storeName: string = '';
  storeId: number = 0;
  warehouseId: number = 0;
  lastModifiedBy: string = '';
  createdById: number = 0;
  lastModifiedAt?: string | null = null;
  lastModifiedById?: number | null = null;
  isDeleted: boolean = false;
  isSelected: boolean = false;
}

export class MovementLineModel {
  departmentId: number = 0;
  departmentDescr?: string;
  categoryId: number = 0;
  categoryName?: string;
  productionCycleId: number = 0;
  locationId: number = 0;
  productionCycle: string = '';
  departmentImage?: string;
  location?: string;
  categoryImage?: string;
  onHand: number = 0;
  color: string = '';
  weekNumber: number = 0;
  amount: number = 0;
  destinationLocation: string = '';
  destinationLocationId: number = 0;
  movementLogs: Array<MovementItemLogModel> = [];
}

export class ProductionCycleModel {
  productionCycleId: number = 0;
  color: string = '';
  displayName: string | null = null;
  productionCycle: string = '';
  active: boolean = false;
  companyId: number = 0;
  createdDt: string | null = null;
  lastUpdatedDt: string | null = null;
  cycleStartDt: string = '';
  cycleEndDt: string = '';
  weekNumber: number = 0;
  sortOrder: number | null = null;
}
export class RumSettings {
  companyId: number = 0;
  enableRumForTpmApp: boolean = false;
  enableRumForPosApp: boolean = false;
  enableRumForListerApp: boolean = false;
  enableRumForCompanyApp: boolean = false;
  id: number = 0;
}

export class ProcessorUsers {
  id: number = 0;
  fullName: string = '';
}
export interface TopPerformer {
  createdByUserId: number;
  totalItems: number;
  totalPrice: number;
  userName: string;
  position: number;
  previousRank: number;
  rank: number;
  profileFileUrl: string;
}

export class UserFavoriteRequestModel {
  userId: number = 0;
  departmentId: number = 0;
  categoryId: number = 0;
  subCategoryId: number = 0;
  companyId: number = 0;
  favoriteId: number = 0;
  active: boolean = false;
  redirectLink?: string;
  createdDt?: Date;
  createdByUserId?: number;
}

export interface BulkDeleteHistoryRequest {
  deletes: string[];
}

export interface FailedToDeleteSerial {
  serialNumber: string;
  message: string;
}

export interface BulkDeleteHistoryResponse {
  totalCount: number;
  failedToDeleteCount: number;
  failedToDeleteSerials: FailedToDeleteSerial[];
}

export interface ScanPullImportReport {
  fileName: string;
  rowsInFile: number;
  uniqueBarcodes: number;
  attemptedCount: number;
  scanPulledCount: number;
  failedCount: number;
  failures: FailedToDeleteSerial[];
  stoppedEarly: boolean;
  errorMessage?: string;
}

export class ProductionMetadata {
  productionCycleId: number = 0;
  userId: number = 0;
  companyId: number = 0;
  storeId: number = 0;
}

export interface WarehouseModel {
  id: number;
  name: string;
}
